<template>
  <div class="vfoot">
  <b-container fulid class="bv-example-row">
    <p @click="open">京 ICP 备 17073622 号-5</p>
    </b-container>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    open(){
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>
<style scoped>
.vfoot{
  border-top: 1px solid;
  padding-top: 17px;
  padding-bottom: 13px;
  height: 57px;
  background-color: #000000ba;
  color: #fff;
}
</style>